var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "h-100 login-page", attrs: { fluid: "" } },
    [
      !_vm.isProduction
        ? _c(
            "div",
            { staticClass: "fixed-bottom w-50 ml-2 mb-2" },
            [
              _c(
                "b-collapse",
                { attrs: { id: "versions" } },
                [
                  _c("b-table", {
                    staticClass: "bg-white",
                    attrs: {
                      hover: "",
                      striped: "",
                      bordered: "",
                      items: _vm.tableData,
                      fields: _vm.table.fields,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "table-busy",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "text-center text-primary my-2",
                                },
                                [
                                  _c("b-spinner", {
                                    staticClass: "align-middle mr-2",
                                  }),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v("Loading...")]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "cell(name)",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: item.azureURL,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "text-nowrap" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(branch)",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: item.branchURL,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "text-nowrap" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.branch) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2823377829
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.versions",
                      modifiers: { versions: true },
                    },
                  ],
                  staticClass: "btn-primary",
                  attrs: { pill: "", size: "lg" },
                },
                [_c("icon", { attrs: { name: "code-fork" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "h-100",
          attrs: { id: _vm.isClient ? "client-portal" : "broker-portal" },
        },
        [
          _c("b-col", {
            staticClass: "d-none d-md-block ellipse-right-in",
            attrs: {
              id: "two-side-login",
              cols: "8",
              md: _vm.isClient ? "5" : "7",
            },
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              attrs: {
                id: "one-side-login",
                cols: "12",
                md: _vm.isClient ? "7" : "5",
              },
            },
            [
              _c(
                "b-container",
                { staticClass: "h-100" },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "h-100 justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", xl: "7", xxl: "7" } },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "justify-content-center align-items-start mb-5",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-2 mb-5 pb-5",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "logo logo-login" },
                                    [
                                      _c("img", {
                                        staticClass: "logo-img",
                                        attrs: { src: _vm.logo, alt: "" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isMfaRequiredAndNotEnabled || _vm.validateMfaCode
                            ? _c(
                                "b-row",
                                { staticClass: "mt-5" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("mfa-container", {
                                        attrs: {
                                          "sending-mfa-code":
                                            _vm.sendingMfaCode,
                                          "mfa-code-delivered":
                                            _vm.mfaCodeDelivered,
                                          "validate-mfa-code":
                                            _vm.validateMfaCode,
                                          "is-mfa-required-and-not-enabled":
                                            _vm.isMfaRequiredAndNotEnabled,
                                          "code-destination":
                                            _vm.codeDestination,
                                          "mfa-preferences": _vm.mfaPreferences,
                                          "mfa-email": _vm.mfaEmail,
                                        },
                                        on: {
                                          enableMfa: _vm.enableMfa,
                                          snoozeMfaSetup: _vm.snoozeMfaSetup,
                                          reSendCode: _vm.reSendCode,
                                          validateMfaAndSignIn:
                                            _vm.validateMfaAndSignIn,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-row",
                                { staticClass: "justify-content-center h-100" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        xs: "8",
                                        sm: "10",
                                        md: "9",
                                        lg: "6",
                                        xl: "12",
                                        xxl: "12",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "bs-0" },
                                        [
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "justify-content-center pt-5 mt-5",
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "p-0 mt-5",
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "title-login text-center",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.isClient
                                                              ? _vm.$t(
                                                                  "global.doorr.clientPortal"
                                                                )
                                                              : _vm.$t(
                                                                  "global.doorr.brokerPortal"
                                                                )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "sign-in text-capitalize account-type",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "account.sign-in"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.isMfaRequiredAndNotEnabled
                                                    ? _c(
                                                        "form",
                                                        {
                                                          staticClass:
                                                            "px-1 mt-4",
                                                          attrs: {
                                                            id: "login-form",
                                                          },
                                                          on: {
                                                            submit: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              $event.preventDefault()
                                                              return _vm.handleSubmit.apply(
                                                                null,
                                                                arguments
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-row",
                                                            {
                                                              staticClass:
                                                                "pt-5 mt-5",
                                                            },
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "p-0 mb-3",
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "material-input",
                                                                    {
                                                                      staticClass:
                                                                        "mx-auto",
                                                                      attrs: {
                                                                        id: "email",
                                                                        "client-login":
                                                                          "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "input-icon",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "i",
                                                                                    {
                                                                                      staticClass:
                                                                                        "material-icons",
                                                                                      attrs:
                                                                                        {
                                                                                          id: "email-icon",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mail_outline"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          1855933744
                                                                        ),
                                                                      model: {
                                                                        value:
                                                                          _vm.email,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.email =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "email",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm.email,
                                                                                expression:
                                                                                  "email",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              id: "email-textarea",
                                                                              "no-auto-complete": false,
                                                                              disabled:
                                                                                _vm.loading,
                                                                              placeholder:
                                                                                _vm.$t(
                                                                                  "account.email"
                                                                                ),
                                                                              "required-indicator":
                                                                                "",
                                                                              type: "email",
                                                                              "on-type":
                                                                                "",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                _vm.email,
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.email =
                                                                                  $event.target.value
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "d-none",
                                                                          attrs:
                                                                            {
                                                                              for: "email-textarea",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                email\n                              "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "p-0",
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "password-input",
                                                                    {
                                                                      staticClass:
                                                                        "mx-auto",
                                                                      attrs: {
                                                                        id: "password",
                                                                        "custom-expression":
                                                                          "password",
                                                                        "client-login":
                                                                          "",
                                                                        password:
                                                                          _vm.password,
                                                                        "validator-context":
                                                                          _vm.$v,
                                                                        placeholder:
                                                                          _vm.$t(
                                                                            "account.password"
                                                                          ),
                                                                        disabled:
                                                                          _vm.loading,
                                                                        "no-auto-complete": false,
                                                                        type: "primary",
                                                                        "required-indicator":
                                                                          "",
                                                                        "on-type":
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        "update:password":
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.password =
                                                                              $event
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.password,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.password =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "password",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-row",
                                                            {
                                                              staticClass:
                                                                "mt-5",
                                                            },
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "text-center p-0",
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "simple-button",
                                                                    {
                                                                      staticClass:
                                                                        "w-100 bold",
                                                                      attrs: {
                                                                        id: "sign-in-button",
                                                                        type: "primary",
                                                                        disabled:
                                                                          !_vm.valid,
                                                                        loading:
                                                                          _vm.loading,
                                                                        "loading-succeeded":
                                                                          _vm.loadingStatus,
                                                                        "client-login":
                                                                          "",
                                                                        "button-type":
                                                                          "submit",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "account.signIn"
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-row",
                                                                {
                                                                  staticClass:
                                                                    "mx-auto mb-5",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      staticClass:
                                                                        "mt-3",
                                                                      attrs: {
                                                                        cols: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: "forgot-password",
                                                                              href: "#/reset-password",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "account.forgotPassword"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "login-legal-disclaimer",
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "global.doorr.loginLegalDisclaimer"
                                                                          )
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "mt-5 pt-5",
                                                                  attrs: {
                                                                    id: "footer",
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "terms-links",
                                                                    {
                                                                      attrs: {
                                                                        "include-rights": false,
                                                                        "client-login":
                                                                          "",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              id: "login-alert",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }